import __request__ from "routing/request";
export function getEngineFingerprint() {
  return __request__("GET", "/system/debug/streams/router_engine_info", null, {}, {
    "Accept": ["application/json"]
  });
}
